
export const BasePageTitle = "Mona Fashion - Online Shop";

// Customer Pages
export const RegistrationTitle = "Registration";
export const SigninTitle = "Sign In";
export const ForgotPasswordTitle = "Forgot Password";